import { render, staticRenderFns } from "./Daqi.vue?vue&type=template&id=35995a50&"
import script from "./Daqi.vue?vue&type=script&lang=js&"
export * from "./Daqi.vue?vue&type=script&lang=js&"
import style0 from "./Daqi.vue?vue&type=style&index=0&id=35995a50&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports